import { create } from 'zustand';

import { TpSlValueState } from '../types';
import { defaultTpSlValue } from './defaultTpSlValue';

export type StopLossState = {
  slValue: TpSlValueState;
  setState: (newSlValue: Partial<TpSlValueState>) => void;
};

export const useStopLossStore = create<StopLossState>()((set) => ({
  slValue: defaultTpSlValue,
  setState: (newSlValue: Partial<TpSlValueState>) =>
    set((_state) => ({
      ..._state,
      slValue: {
        ..._state.slValue,
        ...newSlValue,
      },
    })),
}));
